import { Location } from '@angular/common'
import { ChangeDetectorRef, Component, ElementRef, Input, Renderer2, ViewChild } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { NomadeService } from '../../../../../nomade/services/nomade.service'
import { DialogService } from '../../../../../services'
import { StateService } from '../../../../../services/App/state.service'
import { takeUntil } from 'rxjs/operators'
import { from, Subject } from 'rxjs'
import { ONE_MB_IN_BYTES } from '../../../../../constants/FileSize'
import { MatTabGroup } from '@angular/material/tabs'

@Component({
	selector: 'atyl-nomade-dossier',
	templateUrl: './nomade-dossier.component.html',
	styleUrls: ['./nomade-dossier.component.scss']
})
export class NomadeDossierComponent {
	@Input() currentDossier: any;
    @Input() urlQuickMenu: any = null;
    allDossiers: any = {};
    dossiersLoaded: boolean = false;
    formulairesActionsList: any[] = [];
    unsubscribe = new Subject<void>();
    destroySubject = new Subject<void>();
    totalFilesSize: number;
    loadedDossier: boolean = false;
    sortedFormsList: any = [];
    @ViewChild('matTabGroup', { static: false }) matTabGroup: MatTabGroup;

	constructor(
		private activatedRoute: ActivatedRoute,
		private nomadeService: NomadeService,
		private el: ElementRef,
		private render: Renderer2,
		private changeDetectorRef: ChangeDetectorRef,
		private dialogService: DialogService,
		private location: Location,
        private stateService: StateService,
        private router: Router
	) { }

	ngOnInit() {
        if(this.currentDossier){
            this.setupDossier();
        }
        else{
            this.nomadeService.getDossierById(parseInt(this.activatedRoute.snapshot.params.id)).subscribe(response => {
                this.currentDossier = this.nomadeService.parse(response)
                this.setupDossier();
            });
        }
        this.loadDossiers();
		this.loadCSS('./assets/css/style.bundle.css');
        this.loadFormTypesList();
	}

    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    setupDossier(){
        from(this.nomadeService.requestes())
        .pipe(
          takeUntil(this.unsubscribe)
        )
        .subscribe(requestes => {
            console.log("requestes",requestes);
            this.setupDossierAddedObjects(requestes);
        });
        this.changeDetectorRef.detectChanges();
    }

	getContact(contacts: any) {
		let list = []
		Object.keys(contacts).forEach((label) => {
			contacts[label] != null &&
				list.push({ libelle: label, value: contacts[label] })
		})
		return list
	}
	private loadCSS(styleUrl: string) {
		return new Promise((resolve, reject) => {
			const styleElement = document.createElement('link')
			styleElement.href = styleUrl
			styleElement.type = 'text/css'
			styleElement.rel = 'stylesheet'
			styleElement.onload = resolve
			this.render.appendChild(this.el.nativeElement, styleElement)
		})
	}
	back(): void {
        this.location.back()
	}

    private loadDossiers() {
        this.dossiersLoaded = false;
		this.nomadeService.dossiers().subscribe(response => {
            this.allDossiers={};
			response.forEach(element => {
                this.allDossiers[element.id] = this.nomadeService.parse(element);
				
			})
            this.dossiersLoaded = true;
			this.changeDetectorRef.detectChanges()
		})
	}

    setupDossierAddedObjects(requestes){
        this.currentDossier.addedObjects = {
            forms:[],
            docs:[]
        };
        this.totalFilesSize = 0;
        if(requestes.length>0){
            requestes.forEach(req => {
                this.addObjectsRequestToList(req);
            });
        }
        this.loadedDossier = true;
        this.changeDetectorRef.detectChanges()
        console.log("formulaire nomades",this.currentDossier);
    }

    addObjectsRequestToList(request: any){
        if(request.method == "webservice.formulaire:set" 
        && request.params.idDemande == 0 
        && request.params.options.dossier != undefined
        && request.params.options.dossier === this.currentDossier.id
        && request.params.options.parentNomadeId != undefined)
        {
            var currentFormGroupIndex = this.currentDossier.addedObjects.forms.findIndex(form => form.nomadeId == request.params.options.parentNomadeId);
            var currentFormGroup = null;
            if(currentFormGroupIndex == -1){
                currentFormGroup = ({
                    nomadeId: request.params.options.parentNomadeId,
                    formId: request.params.options.parentForm,
                    formLibelle: request.params.options.parentLibelle,
                    dateModif : request.params.options.demande_date_debut,
                    underFormsReq: []
                })
                currentFormGroup.underFormsReq.push(request);
                this.currentDossier.addedObjects.forms.push(currentFormGroup);
            }
            else{
                currentFormGroup = this.currentDossier.addedObjects.forms[currentFormGroupIndex];
                currentFormGroup.underFormsReq.push(request);
                if(!currentFormGroup.dateModif){
                    currentFormGroup.dateModif = request.params.options.demande_date_debut;
                }
                this.currentDossier.addedObjects.forms[currentFormGroupIndex] = currentFormGroup;
            }
            this.sortFormsByDate();
        }
        else if(request.method == "webservice.document:setFromNomade"){
            const doc = request.params.documents[0];
            this.totalFilesSize += doc.document.value.size/ONE_MB_IN_BYTES;
            if(request.params.options.dossier != undefined
            && request.params.options.dossier === this.currentDossier.id){
                if(this.currentDossier.addedObjects.docs == undefined)
                    this.currentDossier.addedObjects.docs = [];
                var docObject = {
                    idRequest: request.id,
                    document: doc,
                    request: request
                }
                if(!this.currentDossier.addedObjects.docs.find(obj=>obj.idRequest == request.id)){
                    this.currentDossier.addedObjects.docs.unshift(docObject);
                }
            }
        }
        this.changeDetectorRef.detectChanges();
    }

    sortFormsByDate(): void {
        this.currentDossier.addedObjects.forms = this.currentDossier.addedObjects.forms.sort((a: any, b: any) => {
          const dateA = new Date(a.dateModif);
          const dateB = new Date(b.dateModif);
          return dateB.getTime() - dateA.getTime();
        });
    }
    
    loadFormTypesList(){
        this.stateService.pages.pipe(takeUntil(this.unsubscribe)).subscribe((pages) => {
            this.formulairesActionsList = [];
            if(pages){
                pages.forEach(page => {
                    page.actions.forEach(action => {
                        if(action.form != undefined && action.form.form != undefined){
                            this.formulairesActionsList.push(action.form)
                        }
                    });
                });
            }
        })
    }
      
    refreshInkBar(){
        //quand ouvert depuis une visite
        setTimeout(() => {
            this.matTabGroup.realignInkBar();
        });
    }

    goToDossier(tiers){
        //var dossierClicked = this.allDossiers.find(doss=>doss.id == tiers.dossierID)
        if(this.allDossiers[tiers.dossierID] != undefined){
            this.currentDossier = this.allDossiers[tiers.dossierID];
            this.setupDossier();
            this.matTabGroup.selectedIndex = 0;
        }
    }
      

}
